export default [
  {
    path: '/quickRepay/index',
    name: 'quickRepay',
    component: () => import('@/view/repayment/quickRepay/index.vue'),
    meta: { pageName: 'page_quick_repay' }
  },
  {
    path: '/quickRepay/rightsList',
    name: 'quickRepayRightsList',
    component: () => import('@/view/repayment/quickRepay/rightsList.vue'),
    meta: { pageName: 'page_quick_repay_bill' }
  },
  {
    path: '/quickRepay/confirm',
    name: 'quickRepayConfirm',
    component: () => import('@/view/repayment/quickRepay/confirm.vue'),
    meta: { pageName: 'page_quick_repay_confirm' }
  },
  {
    path: '/quickRepay/result',
    name: 'quickRepayResult',
    component: () => import('@/view/repayment/quickRepay/result.vue'),
    meta: { pageName: 'page_quick_repay_result' }
  } 
]